"use client";

import { useMediaQuery } from "@mui/material";

function WithFooter({ children }) {
  const isDesktopView = useMediaQuery("(min-width: 1600px)");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: isDesktopView && "calc(100vh - 410px)",
      }}
    >
      <div style={{ flex: "1 0 auto" }}>{children}</div>
    </div>
  );
}
export default WithFooter;
